interface LinearConnectionFields {
	linearOrganizationId?: string | null
	linearTokenRevoked?: boolean | null
}

// The Linear token itself never reaches the client. A workspace is connected
// while it holds a Linear organization and the token has not been revoked.
export function hasLinearConnection<
	T extends LinearConnectionFields | null | undefined,
>(
	workspace: T,
): workspace is NonNullable<T> & { linearOrganizationId: string } {
	return !!workspace?.linearOrganizationId && !workspace.linearTokenRevoked
}
